// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.hint[data-v-1e6a0eaa] {\n\tfont-size: 0.85em;\n\topacity: 0.75;\n\tmargin: 8px 0 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
